import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ViewportService } from 'src/app/services/viewport.service';

@Component({
  selector: 'support-modal',
  templateUrl: './support-modal.component.html',
  styleUrl: './support-modal.component.css'
})
export class SupportModalComponent implements OnInit, OnDestroy{
  @Input() visible = false;
  @Output() onClose = new EventEmitter<void>();

  constructor(
      public ref: DynamicDialogRef,
      public config: DynamicDialogConfig,
      public viewport: ViewportService
  ) {}

  ngOnInit() {}
  ngOnDestroy(): void {}

  hide() {
      this.onClose.emit();
  }

  close() {
      this.ref.close(); // this will destroy the dialog
  }
}
